import { user_state, theme_color, user_data, inbox_count } from "./StateTypes";

const initialState = {
    userState: false,
    themeColor: "#00a389",
    userData: {
        accessToken: "",
        displayName: "",
        email: "",
        emailVerified: "",
        photoURL: "",
        uid: "",
    },
    inboxCount: 0
};

const StateReducers = (state = initialState, action) => {
    switch (action.type) {
        case user_state:
            return {
                ...state,
                userState: action.payload,
            };
        case theme_color:
            return {
                ...state,
                themeColor: action.payload,
            };
        case user_data:
            return {
                ...state,
                userData: { ...action.payload },
            };
        case inbox_count:
            return {
                ...state,
                inboxCount: action.payload,
            };
        default:
            return state;
    }
};

export default StateReducers;